import {Pipe, PipeTransform} from "@angular/core";
import {ScheduledSound, ScheduledSoundOffsetType} from "@models";

@Pipe({
	name: "scheduledSoundOffset",
})
export class ScheduledSoundOffsetPipe implements PipeTransform {
	transform(scheduledSound: ScheduledSound, phaseDuration: number): number {
		if (scheduledSound.offsetType === ScheduledSoundOffsetType.FromStart) {
			return scheduledSound.offset;
		} else {
			return Math.max(0, phaseDuration - scheduledSound.offset);
		}
	}
}
